import { getFederalStates, getLandesclubsTelephone } from '@/api/myTermine'

function defaultStatesState() {
  return {
    selectedState: null,
  }
}

export default {
  state: () => ({
    ...defaultStatesState(),
    federalStates: [],
    landesclubsTelephone: [],
  }),
  actions: {
    async getFederalStates({ commit }) {
      try {
        const response = await getFederalStates()
        commit('setFederalStates', response.data.items)
      } catch (error) {
        console.error(error)
      }
    },
    async getLandesclubsTelephone({ commit }) {
      try {
        const response = await getLandesclubsTelephone()
        commit('setLandesclubsTelephone', response.data.items)
      } catch (error) {
        console.error(error)
      }
    },
  },
  mutations: {
    resetStatesState(state) {
      Object.assign(state, {
        ...state,
        ...defaultStatesState(),
      })
    },
    setFederalStates(state, payload) {
      state.federalStates = payload.sort((a, b) => {
        const nameA = a.bezeichnung.toLowerCase()
        const nameB = b.bezeichnung.toLowerCase()
        if (nameA < nameB) {
          return -1
        }
        return 1
      })
    },
    setSelectedState(state, payload) {
      state.selectedState = payload
    },
    setLandesclubsTelephone(state, payload) {
      state.landesclubsTelephone = payload
    },
  },
  getters: {
    federalStates(state) {
      return state.federalStates
    },
    selectedState(state) {
      return state.selectedState
    },
    landesclubTelephone(state) {
      return state.landesclubsTelephone?.find(
        (landesclub) => landesclub.id === state.selectedState?.landesclubId
      )?.telefon
    },
  },
}
